
import { storeToRefs } from "pinia";
import { OSAddressProvider } from "@/types";
import { useBooks, useOrgSettings } from "@/services";
import { defineComponent, onMounted, computed } from "vue";

export default defineComponent({
  name: "DataTaggingModal",
  setup() {
    const books = useBooks();
    const orgSettings = useOrgSettings();
    const { dataSetDefinition, risks, geocoderData, isGeocodingEnabled } =
      storeToRefs(books);
    let ids: string[] = [];
    const isGeocodingEnable = computed({
      get() {
        return books.isGeocodingEnabled;
      },
      set(isEnabled: boolean) {
        books.setGeocodingEnabled(isEnabled);
      },
    });
    const dataTaggingValid = computed(() => books.isDataTaggingValid);

    onMounted(() => {
      books.setRisks(
        orgSettings.settings?.bookUploaderSettings?.riskDataSets || []
      );
    });

    const hasAddressId = computed(
      () => books.hasAddressId || isGeocodingEnabled.value
    );
    const providerDictionary = computed(
      () =>
        orgSettings.addressSettings?.providers.reduce((prev, current) => {
          if (prev.has(current.country)) {
            prev.set(current.country, [
              ...(prev.get(current.country) || []),
              current,
            ]);
          } else {
            prev.set(current.country, [current]);
          }
          return prev;
        }, new Map<string, OSAddressProvider[]>()) ||
        new Map<string, OSAddressProvider[]>()
    );
    const countries = computed(() =>
      Array.from(providerDictionary.value.keys())
    );
    const providers = computed(() =>
      providerDictionary.value.get(geocoderData.value.country || "")
    );

    return {
      ids,
      risks,
      countries,
      providers,
      geocoderData,
      hasAddressId,
      isGeocodingEnable,
      dataTaggingValid,
      dataSetDefinition,
    };
  },
});
